"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveHeight = exports.transparentImageBg = exports.imageCover = exports.coverBg = void 0;

var _styledComponents = require("styled-components");

var _spacing = require("./spacing");

var _positioning = require("./positioning");

var coverBg = (0, _styledComponents.css)(["background-size:cover;background-position:center center;"]);
exports.coverBg = coverBg;
var imageCover = (0, _styledComponents.css)(["object-fit:cover;position:absolute;", " ", ""], _spacing.fill, (0, _positioning.pin)(0, 'top', 'left'));
exports.imageCover = imageCover;
var transparentImageBg = (0, _styledComponents.css)(["background-position:0 0,10px 10px;background-size:20px 20px;background-image:linear-gradient( 45deg,#eee 25%,transparent 25%,transparent 75%,#eee 75%,#eee 100% ),linear-gradient(45deg,#eee 25%,white 25%,white 75%,#eee 75%,#eee 100%);"]);
exports.transparentImageBg = transparentImageBg;

var responsiveHeight = function responsiveHeight(paddingBottomPercent) {
  return (0, _styledComponents.css)(["height:0;padding-bottom:", "%;position:relative;"], paddingBottomPercent);
};

exports.responsiveHeight = responsiveHeight;